import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BackEndService } from 'src/app/backend-service';
import { Widget } from 'src/app/classes';
import { WidgetService } from 'src/app/services/widget.service';

@Component({
  selector: 'app-edit-foreign-dashboard-standalone',
  templateUrl: './edit-foreign-dashboard-standalone.component.html',
  styleUrls: ['./edit-foreign-dashboard-standalone.component.css']
})
export class EditForeignDashboardStandaloneComponent implements OnDestroy, OnInit {

  _currentUsername: string;
  set currentUsername(name: string){
    this._currentUsername = name;
    this.loadWidgetPage();
  }
  get currentUsername(): string {
    return this._currentUsername;
  }

  widgets: Widget[];
  widgetsReady: boolean = false;
  pageLoadingSubscription: Subscription;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _backEndService: BackEndService,
    private _widgetService: WidgetService,
    private _route: ActivatedRoute
  ) { }

  loadWidgetPage(){
    if(this.currentUsername){
      this.pageLoadingSubscription = this._backEndService.get("api/widget/user/" + this.currentUsername).subscribe((widgets: Widget[]) => {
        this.widgets = widgets;
        this.widgetsReady = true;
      });
    }
  }

  ngOnDestroy(){
    if(this.pageLoadingSubscription) this.pageLoadingSubscription.unsubscribe();
    this.pageLoadingSubscription = null;
  }

  ngOnInit() {
    this._subscriptions.push(this._route.queryParams.subscribe((params) => {
      if(params['username']){
        this.currentUsername = params['username'];
      }
    }));
  }

  widgetAdded(result: Widget){
    this.widgets.push(result);
  }

  widgetDeleted(result: Widget){
    let i = this.widgets.indexOf(result);
    if(i > -1) {
      this.widgets.splice(i, 1);
    }
  }

}
